// @flow
import React, { Component, Fragment } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage, intlShape } from 'react-intl';
import Cleave from 'cleave.js/dist/cleave-react';
import { Element } from 'react-scroll/modules';
import InputPrice from '../../../../../elements/InputPrice/InputPrice';
import Modal from '../../../../../elements/Modal/Modal';
import {CommaFormat} from '../../../../../elements/Price/Price';
import Select from '../../../../../elements/Select/Select';
import RadioButton from '../../../../../elements/RadioButton/RadioButton';
import { FormValidator } from '../../../../../utils/form';
import DetailOption from '../DetailOption/DetailOption';
import VolumetricOptions from '../ProductForm/VolumetricOptions/VolumetricOptions';
import InputQuantity from '../../../../../elements/InputQuantity/InputQuantity';
import InputWeight from '../../../../../elements/InputWeight/InputWeight';
// import Rating from '../../../../../elements/Rating/Rating';
import { Desktop, Mobile, Tablet } from '../../../../../utils/responsive';
import FloatingBottom from '../../../../../elements/FloatingBottom/FloatingBottom';
import environment from "../../../../../environment";
import { copyToClipboard } from "../../../../../utils/clipboard";

import style from './AmazonProductForm.scss';
import formStyle from '../../../../../assets/styles/form.scss';
// import inputStyle from '../../../../../assets/styles/input.scss';
import icons from '../../../../../assets/styles/icons.scss';
import buttonStyle from '../../../../../assets/styles/button.scss';
import withBoxImg from '../../../../../assets/img/new-order/with-box.png';
import withoutBoxImg from '../../../../../assets/img/new-order/without-box.png';
import firstBenefit from '../../../../../assets/img/new-order/product-step/award_light_blue.png';
import secondBenefit from '../../../../../assets/img/new-order/product-step/truck_light_blue.png';
import thirdBenefit from '../../../../../assets/img/new-order/product-step/shield_light_blue.png';

import type { Category, ScrappedDetailOptionItem, ScrappedProduct } from '../../../../../entities';
import type { InputQuantityAction } from '../../../../../elements/InputQuantity/InputQuantity';
import type { LocaleState } from '../../../../locale/duck';
import type { LocalValuesState } from '../../../../local-values/duck';
import type { Option } from '../../../../../elements/Select/Select';
import type { Location as RouterLocation } from "../../../../../router";

type Props = {
  +handleFocusInputText: (e: Event) => void;
  +handleBlurCleave: (e: Event) => void;
  +handleWeightInit: (cleave: Cleave) => void;
  +handlePriceInit: (cleave: Cleave) => void;
  +handleChangeCleave: (e: Event) => void;
  +handleChangeCategory: (option: Option) => void;
  +handleChangeAmount: (action: InputQuantityAction) => void;
  +handleChangeWeightUnit: (index: string) => void;
  +handleChangeVolume: (value: number) => void;
  +handleChangeBoxOption: (index: number) => void;
  +handleClickAddCart: () => void;
  +handleClickBuyNow: () => void;
  +categories?: Category[];
  +locale: LocaleState;
  +location: RouterLocation;
  +localValues: LocalValuesState;
  +departureCountry: {
    value: string;
    errors?: string[];
  };
  +name: {
    value: string;
    errors?: string[];
  };
  +image: {
    value?: string;
    valueURI?: string;
    errors?: string[];
  };
  +description: {
    value: string;
    errors?: string[];
  };
  +shipping: string;
  +price: {
    value: string;
    errors?: string[];
  };
  +categoryId: {
    value: string;
    errors?: string[];
  };
  +amount: {
    value: number;
    errors?: string[];
  };
  +weightUnit: {
    value: string;
  };
  +weight: {
    value: string;
    errors?: string[];
  };
  +volumeTier: {
    value: ?number;
    code: string;
    errors?: string[];
  };
  +withBox: {
    value: number;
    errors?: string[];
  };
  +isScrapping: boolean;
  +hideOptions: boolean;
  // +chosenVariants?: { [key: string]: number };
  +scrappedProduct?: ScrappedProduct;
  +handleChangeDetailOption: (dimension: string, value: string) => void;
  +getVariantFromStateDetailOption: () => ?ScrappedDetailOptionItem;
  +detailOptions: {
    [key: string]: {
      value: string;
      errors?: string[];
      disabled?: {
        [key: string]: boolean;
      };
    };
  };
  +vendorData: { [key: string]: any };
};

type State = {
  selectedImageIndex: number;
  detailCount: number;
  detailOpen: boolean;
  isBrowser: boolean;
  revisionHintModalOpen: boolean;
};

const withBoxOptions = [
  {
    intl: 'newOrder.product.form.box.no.amazon',
    img: withoutBoxImg,
    alt: 'withoutBox',
  },
  {
    intl: 'newOrder.product.form.box.yes.amazon',
    img: withBoxImg,
    alt: 'withBox',
  },
];

const messages = defineMessages({
  description: {
    id: 'newOrder.amazon.product.description',
  },
});

const buildPublicUrl = (locale: LocaleState, location: RouterLocation) =>
  `${environment.baseUrl[locale.domainCountry || 'US']}${location.pathname}${location.search}`;

const buildMessage = (locale: LocaleState, location: RouterLocation,
                      formatMessage: (value: { [id: string]: string }) => string) =>
  `${formatMessage(messages.description)} ${buildPublicUrl(locale, location)}`;

export default class AmazonProductForm extends Component<Props, State> {
  state = {
    selectedImageIndex: 0,
    detailCount: 100,
    detailOpen: true,
    isBrowser: false,
    revisionHintModalOpen: false,
  };
  addToCartId: string = 'addToCartButton';

  componentDidMount() {
    this.setState({
      isBrowser: true,
    });
  }

  handleSelectImage = (index: number) => {
    const { vendorData } = this.props;
    if (vendorData && vendorData.image_url_set && vendorData.image_url_set.length !== 0) {
      this.setState({ selectedImageIndex: index });
    }
  };

  handleClickFBSharedDialog = () => {
    const { locale, location } = this.props;
    const shareUrl = buildPublicUrl(locale, location);
    const message = buildMessage(locale, location, this.context.intl.formatMessage);
    if (!(window: any).FB) return;
    (window: any).FB.ui({
      method: 'share',
      href: shareUrl,
      quote: message,
    }, (response) => console.log(response));
  };

  handleClickTwitterShare = () => {
    const { locale, location } = this.props;
    const message = buildMessage(locale, location, this.context.intl.formatMessage);
    const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(message)}`;
    const width = 550;
    const height = 500;
    const options = `height=${height},width=${width},resizable=yes,toolbar=no,menubar=no,location=no,directories=no,status=yes`;
    window.open(url, 'popUpWindow', options);
  };

  handleCopyUrl = (urlRedirect: string) => {
    copyToClipboard(urlRedirect);
    // If you want to let the user know he's copied the url
    // this.setState({ copyUrlClicked: true });
  };

  getHighLowPrices = (variations: { [key: string]: ScrappedDetailOptionItem }, off?: string) => {
    const variationsKeys = Object.keys(variations);
    // NEGATIVE_INFINITY and POSITIVE_INFINITY set as fallback because first variation prices can be null
    let highestPrice: number = variations[variationsKeys[0]].vendorData.lowest_price || Number.NEGATIVE_INFINITY;
    let lowestPrice: number = variations[variationsKeys[0]].vendorData.highest_price || Number.POSITIVE_INFINITY;
    variationsKeys.forEach((productId: string) => {
        const currentLowest = variations[productId].vendorData.lowest_price;
        // We don't want the next lowest price to evaluate to be null and set lowestPrice to 0
        if (!currentLowest) return;
        highestPrice = Math.max(highestPrice, variations[productId].vendorData.highest_price);
        lowestPrice = Math.min(lowestPrice, currentLowest);
      },
    );
    if (highestPrice === lowestPrice) {
      return (
        <h1 className={classNames(style.priceText, { [style.priceNoOff]: !off })}>
          $ {parseFloat(highestPrice).toFixed(2)}
        </h1>);
    } else {
      return (
        <h1 className={classNames(style.priceText, style.highLowPrice, { [style.priceNoOff]: !off })}>
          $ {parseFloat(lowestPrice).toFixed(2)} - $ {parseFloat(highestPrice).toFixed(2)}
        </h1>);
    }
  }

  render() {
    const {
      handleFocusInputText, handleBlurCleave, handleWeightInit, handleChangeCleave, handleChangeCategory, handleChangeAmount,
      handleChangeWeightUnit, handleClickAddCart, handleClickBuyNow, handleChangeBoxOption, categories, name,
      description, price, categoryId, amount, weightUnit, weight, shipping, withBox, isScrapping, hideOptions,
      volumeTier, handleChangeVolume, localValues, locale, location, scrappedProduct, handleChangeDetailOption,
      detailOptions, vendorData, image, handlePriceInit, getVariantFromStateDetailOption,
    } = this.props;
    const { selectedImageIndex, detailCount, detailOpen, isBrowser, revisionHintModalOpen } = this.state;

    const categoryOptions: Option[] = (categories || [])
      .filter((category: Category) => category.enabled)
      .map((category: Category) => {
        return ({
          value: category.id,
          label: category.translations[locale.locale.toUpperCase()].name,
        })
      });

    const urlRedirect = `${environment.baseUrl[locale.domainCountry || 'US']}${location.pathname}${location.search}`;

    const categoryError = !!categoryId.errors && FormValidator.buildErrorLabel(categoryId.errors, {
      required: 'newOrder.product.form.category.error.required',
      unscrapped: 'newOrder.product.form.category.error.unscrapped',
    });

    const weightError = !!weight.errors && FormValidator.buildErrorLabel(weight.errors, {
      required: 'newOrder.product.form.weight.error.required',
      greaterThanZero: 'newOrder.product.form.weight.error.greaterThanZero',
      lessThanFiveKg: 'newOrder.product.form.weight.error.lessThanFiveKg',
      unscrapped: 'newOrder.product.form.weight.error.unscrapped',
    });

    const withBoxError = !!withBox.errors && FormValidator.buildErrorLabel(withBox.errors, {
      required: 'newOrder.product.form.box.error.required',
    });

    const priceError = !!price.errors && FormValidator.buildErrorLabel(price.errors, {
      required: 'newOrder.product.form.price.error.required',
      unscrapped: 'newOrder.product.form.price.error.unscrapped',
    });

    const volumetricCat = localValues && localValues.categoriesMap;

    const hasVolumetricOptions = !!volumetricCat && !!volumetricCat[categoryId.value] &&
      volumetricCat[categoryId.value].volumeTiers.length !== 0;

    const scrappedImage = scrappedProduct ? scrappedProduct.image : undefined;
    const defaultImages = scrappedImage ? [scrappedImage] : [];
    const vendorDataDefaultImages = image.value ? [image.value] : defaultImages;
    const images = vendorData && vendorData.image_url_set ? [image.value, ...vendorData.image_url_set] : vendorDataDefaultImages;

    const buttons = <Fragment>
      <FormattedMessage id="newOrder.products.form.button.quoteNow">{
        txt => <button className={classNames(buttonStyle.btn, buttonStyle.lightBlue)}
                       onClick={handleClickBuyNow}>{txt}</button>
      }</FormattedMessage>
      <FormattedMessage id="newOrder.products.form.button.addCart">{
        txt => <button id={this.addToCartId}
                       className={classNames(buttonStyle.btn, buttonStyle.orange)}
                       onClick={handleClickAddCart}>
          {txt}</button>
      }</FormattedMessage>
    </Fragment>;

    const imagesWrap = <div className={style.productImagesWrap}>
      <div className={style.selectedImageSizerWrap}>
        <div className={style.selectedImageSquareWrap}>
          <div className={style.selectedImageContentWrap}>
            {!!images[selectedImageIndex] &&
            <img src={images[selectedImageIndex]}
                 alt={name.value}
                 className={style.image}/>}
          </div>
        </div>
      </div>
      <div className={style.imagesCarousel}>
        {!!images && images.map((image: string, index: number) =>
          <div key={index}
               className={style.imgWrap}>
            <img src={image}
                 alt={`${name.value}-index`}
                 className={classNames(style.image, { [style.selected]: selectedImageIndex === index })}
                 onClick={() => this.handleSelectImage(index)}/>
          </div>)}
      </div>
    </div>;

    const titleWrap = <div className={style.productTitleWrap}>
      {/*Name*/}
      <h3 className={style.name}>{name.value}</h3>
      {/*<Rating rating={3.25}
              totalRating={5}
              className={style.rating}/>*/}
      <div className={style.reviewsWrap}>
        <i className={icons.iconStarMedium}/>
        <FormattedMessage id="newOrder.amazon.product.rating.label">{
          txt => <a className={style.reviews}
                    target="_blank"
                    href={vendorData.comments_url}>{txt}</a>
        }</FormattedMessage>
      </div>
      <div className={style.tags}>
        {vendorData.best_seller &&
        <button className={classNames(style.tag, style.orange)}>
          Best Seller
        </button>}
        {vendorData.condition === "New" &&
        <button className={classNames(style.tag, style.green)}>
          New
        </button>}
      </div>
      <hr className={style.desktop}/>
    </div>;

    const mainWrap = <div className={style.productMainWrap}>
      <form className={classNames(formStyle.formWrap)}
            onSubmit={(e: Event) => e.preventDefault()}
            autoComplete="off">
        {/*Detail Options*/}
        {!!scrappedProduct && !!scrappedProduct.detailOptions &&
        <div className={style.detailsWrap}>
          {Object.keys(scrappedProduct.detailOptions.variationDimensions).map((key: string, idx: number) =>
            <DetailOption key={idx}
                          dimension={key}
                          handleChange={handleChangeDetailOption}
                          selectedOption={detailOptions[key]}
                          options={scrappedProduct.detailOptions.variationDimensions[key]}/>)}
        </div>}
        {/*Description*/}
        {/*(!scrappedProduct || (!!scrappedProduct && !scrappedProduct.detailOptions)) &&
        <div className={classNames(formStyle.row, formStyle.inputRow, style.description)}>
          <FormattedMessage id="newOrder.product.form.description.label">{
            txt => (<label className={formStyle.label}>{txt}:
              <span className={formStyle.optional}>
                    {this.context.intl.formatMessage({ id: 'newOrder.product.form.url.optional.label' })}
                  </span>
            </label>)
          }</FormattedMessage>
          <FormattedMessage id="newOrder.product.form.description.count">{
            txt => (<label className={classNames(formStyle.label, style.counter)}>{detailCount}
              {detailCount === 1 ? ` ${txt}` : ` ${txt.replace('Ã¡', 'a')}es`}</label>)
          }</FormattedMessage>
          <p className={classNames(inputStyle.input, {
            [inputStyle.lightBlue]: description && description.value,
          })}>{description.value}</p>
        </div>*/}
        <div className={classNames(formStyle.row,
          { [style.category]: hasVolumetricOptions })}>
          {/*Category*/}
          <FormattedMessage id="newOrder.product.form.category.label">{
            txt => (<label className={formStyle.label}>{txt}:</label>)
          }</FormattedMessage>
          <FormattedMessage id="newOrder.product.form.category.placeholder">{
            txt => <Select options={categoryOptions}
                           id="categoryId"
                           className={classNames({
                             'light-blue': categoryId && categoryId.value,
                             'red': categoryId && categoryId.errors && categoryId.errors[0] !== 'unscrapped',
                             'yellow': categoryId && categoryId.errors && categoryId.errors[0] === 'unscrapped',
                           })}
                           value={categoryId.value}
                           hasError={!!categoryId.errors}
                           placeholder={txt}
                           handleChange={handleChangeCategory}/>
          }</FormattedMessage>
          {categoryError}
        </div>
        {categoryId.value === '9' && <FormattedMessage id="newOrder.product.form.revision.hint">{
          txt => <span className={style.revisionHint}>
                <i className={icons.symbolWarning}/>{txt} <button onClick={() => this.setState({revisionHintModalOpen: true})}><i className={icons.symbolQuestionCircle} /></button>
              </span>
        }</FormattedMessage>}
        {/* Weight */}
        {!!localValues.categoriesMap && !!categoryId.value &&
        localValues.categoriesMap[`${categoryId.value}`].criteria === 'WEIGHT' &&
        <div className={formStyle.row}>
          <FormattedMessage id="newOrder.product.form.weight.label">{
            txt => (<label className={formStyle.label}>{txt}:</label>)
          }</FormattedMessage>
          <InputWeight name="weight"
                       value={weight.value}
                       hasError={!!weight.errors}
                       errors={weight.errors}
                       weightUnit={weightUnit}
                       handleBlurCleave={handleBlurCleave}
                       handleFocusInputText={handleFocusInputText}
                       handleChangeCleave={handleChangeCleave}
                       handleChangeWeightUnit={handleChangeWeightUnit}
                       handleInit={handleWeightInit}
          />
          {weightError}
        </div>}

        {/* Volume tier */}
        {!!volumetricCat && hasVolumetricOptions &&
        <section className={formStyle.row}>
          <Element name="volumeTier">
            <VolumetricOptions value={volumeTier.value}
                               onChange={handleChangeVolume}
                               localeState={locale}
                               errors={volumeTier.errors}
                               category={volumetricCat[categoryId.value]}/>
          </Element>
        </section>}

        {/* With box */}
        {!!localValues.categoriesMap && !!categoryId.value &&
        localValues.categoriesMap[`${categoryId.value}`].originalPackagingSelectable &&
        <div className={classNames(formStyle.row, formStyle.rowNoMargin)}>
          <FormattedMessage id="newOrder.product.form.box.label">{
            txt => (<label className={classNames(formStyle.label, style.withBoxLabel)}>{txt}</label>)
          }</FormattedMessage>
          <Element name="withBox">
            <div className={classNames(formStyle.row, formStyle.rowNoMargin, formStyle.dualWrap,
              formStyle.responsiveMedium)}>
              {withBoxOptions.map((option: { [key: string]: string }, index: number) =>
                (<article key={index}
                          className={classNames(formStyle.col, style.col)}
                          onClick={() => handleChangeBoxOption(index)}>
                  <div className={classNames(style.wrapper,
                    { [style.selected]: withBox.value === index })}>
                    <RadioButton name="withBox"
                                 value={index}
                                 selected={withBox.value}
                                 handleChange={_ => {
                                 }}/>
                    <img src={option.img} alt={option.alt}/>
                    <FormattedMessage id={option.intl}>{
                      txt => <p>{txt}</p>
                    }</FormattedMessage>
                  </div>
                </article>),
              )}
              {withBoxError}
            </div>
          </Element>
        </div>}
      </form>
    </div>;

    const s = getVariantFromStateDetailOption();

    const highPriceFloat = vendorData && vendorData.highest_price ?
      parseFloat(vendorData.highest_price) : undefined;

    const priceFloat = price.value ? parseFloat(price.value) : undefined;
    
    const shouldShowOff = s && vendorData && vendorData.highest_price &&
      !isNaN(highPriceFloat) && !isNaN(priceFloat) &&
      typeof highPriceFloat === 'number' && typeof priceFloat === 'number' && (highPriceFloat > priceFloat);

    const off = shouldShowOff && typeof highPriceFloat === 'number' && typeof priceFloat === 'number' ?
      (((highPriceFloat - priceFloat) / highPriceFloat) * 100).toFixed(0) : undefined;

    const priceWrap = <div className={style.productPriceWrap}>
      {/* NOTE: s.price and price.value should be the same */}
      {/*s && s.price &&
      <h1 className={classNames(style.priceText, { [style.priceNoOff]: !off })}>
        $ {CommaFormat({price: price.value})}
      </h1>*/}
      {/*!s && !!detailOptions && scrappedProduct && !!scrappedProduct.detailOptions &&
      this.getHighLowPrices(scrappedProduct.detailOptions.variations, off)*/}
      {/*((s && !s.price) || (scrappedProduct && !scrappedProduct.detailOptions)) &&*/
      <Fragment>
        <div className={classNames(formStyle.formWrap, style.price)}>
          <div className={classNames(formStyle.row, formStyle.rowNoMargin)}>
            <FormattedMessage id="newOrder.product.form.price.label">{
              txt => (<label className={formStyle.label}>{txt}:</label>)
            }</FormattedMessage>
            <InputPrice name="price"
                        value={price.value}
                        hasError={!!price.errors}
                        errors={price.errors}
                        handleFocusInputText={handleFocusInputText}
                        handleChangeCleave={handleChangeCleave}
                        handleBlurCleave={handleBlurCleave}
                        handleInit={handlePriceInit}
            />
            {priceError}
          </div>
        </div>
      </Fragment>}
      {off &&
      <div className={style.oldPriceWrap}>
        <p className={style.oldPrice}>${vendorData.highest_price}</p>
        &nbsp;
        <p className={style.offPrice}>({off}% OFF)</p>
      </div>}
      {!!shipping &&
      <div className={style.shipping}>
        <p>{`+ $${shipping} shipping`}</p>
      </div>}
      {/*<p className={style.stockLeft}>¡Quedan solo 15!</p>*/}
      {/*Quantity*/}
      <div className={classNames(formStyle.formWrap, style.quantity)}>
        <div className={classNames(formStyle.row, formStyle.rowNoMargin)}>
          <FormattedMessage id="newOrder.product.form.quantity.label">{
            txt => (<label className={formStyle.label}>{txt}:</label>)
          }</FormattedMessage>
          <InputQuantity disableLess={amount.value === 1}
                         disableMore={amount.value === 5}
                         quantity={amount ? `${amount.value}` : `1`}
                         handleChange={handleChangeAmount}/>
        </div>
      </div>
      <hr className={style.tablet}/>
      <div className={classNames(style.buttonsWrap, style.onlyDefault)}>
        {buttons}
      </div>
      <Mobile>
        <FloatingBottom offSetY={146}>
          <div className={style.buttonsWrap}>
            {buttons}
          </div>
        </FloatingBottom>
      </Mobile>
    </div>;

    const benefitsWrap = <div className={style.benefits}>
      <FormattedMessage id="newOrder.amazon.product.benefits.title">{
        txt => <p className={style.title}>{txt}</p>
      }</FormattedMessage>
      <FormattedMessage id="newOrder.amazon.product.benefits.first">{
        txt => <div className={style.benefit}>
          <div className={style.imgWrap}>
            <img src={firstBenefit} alt="firstBenefit"/>
          </div>
          <p>{txt}</p>
        </div>
      }</FormattedMessage>
      <FormattedMessage id="newOrder.amazon.product.benefits.second">{
        txt => <div className={style.benefit}>
          <div className={style.imgWrap}>
            <img src={secondBenefit} alt="secondBenefit"/>
          </div>
          <p>{txt}</p>
        </div>
      }</FormattedMessage>
      <FormattedMessage id="newOrder.amazon.product.benefits.third">{
        txt => <div className={style.benefit}>
          <div className={style.imgWrap}>
            <img src={thirdBenefit} alt="thirdBenefit"/>
          </div>
          <p>{txt}</p>
        </div>
      }</FormattedMessage>
    </div>;

    const mediaWrap = <div className={style.mediaWrap}>
      <FormattedMessage id="newOrder.amazon.product.share">{
        txt => <p className={style.share}>{txt}:</p>
      }</FormattedMessage>
      <div className={style.media}>
        <div className={classNames(style.method, style.twitter)}
             onClick={_ => this.handleClickTwitterShare()}>
          <i className={icons.symbolTwitter}/>
        </div>
        <div className={classNames(style.method, style.facebook)}
             onClick={_ => this.handleClickFBSharedDialog()}>
          <i className={icons.symbolFacebook}/>
        </div>
        <div className={classNames(style.method, style.link)}
             onClick={_ => this.handleCopyUrl(urlRedirect)}>
          <i className={icons.symbolLink}/>
        </div>
      </div>
    </div>;

    const descriptionProductWrap = vendorData && vendorData.features_description &&
      <Fragment>
        <hr className={style.descriptionHr}/>
        <div className={style.descriptionWrap}>
          <FormattedMessage id="newOrder.amazon.product.detail.title">{
            txt => <h3 className={style.detailTitle}
                       onClick={() => this.setState((st: State) => ({ detailOpen: !st.detailOpen }))}>{txt}
              <i className={!detailOpen ? icons.iconChevronUpMedium : icons.iconChevronDownMedium}/></h3>
          }</FormattedMessage>
          {detailOpen &&
          <ul>
            {vendorData.features_description.map((feature: string, index: number) => <li key={index}>{feature}</li>)}
          </ul>}
        </div>
      </Fragment>;
    
    const generateWhatsappLink = (whatsappNumber: string, text: string) =>
      `https://wa.me/${whatsappNumber}?text=${text}`;

    return (isBrowser &&
      <Fragment>
        <div className={style.amazonWrapFullWidth}>
          <div className={classNames(style.amazonFormWrap, style.desktop)}>
            <div className={classNames(style.column, style.left)}>{imagesWrap}</div>
            <div className={classNames(style.column, style.center)}>
              {titleWrap}
              {mainWrap}
            </div>
            <div className={classNames(style.column, style.right)}>
              {priceWrap}
              {benefitsWrap}
              {mediaWrap}
            </div>
          </div>
          <Desktop>
            {descriptionProductWrap}
          </Desktop>
        </div>
        <div className={style.amazonWrapFullWidth}>
          <div className={classNames(style.amazonFormWrap, style.tablet)}>
            <div className={classNames(style.column, style.left)}>
              {titleWrap}
              {imagesWrap}
              {mainWrap}
            </div>
            <div className={classNames(style.column, style.right)}>
              {priceWrap}
              {benefitsWrap}
              {mediaWrap}
            </div>
          </div>
          <Tablet>
            {descriptionProductWrap}
          </Tablet>
        </div>
        <div className={classNames(style.amazonFormWrap, style.mobile)}>
          <div className={classNames(style.column)}>
            {titleWrap}
            {imagesWrap}
            {priceWrap}
            {mainWrap}
            {benefitsWrap}
            {mediaWrap}
            {descriptionProductWrap}
          </div>
        </div>
        <Modal open={revisionHintModalOpen}
               handleClose={() => this.setState({revisionHintModalOpen: false})}
               closeOnEsc>
          <h2 className={style.modalTitle}>Revisión de pedido</h2>

          <p className={style.modalText}>
            Una vez realices tu pedido, un miembro de nuestro
            equipo revisará que la cotización esté correcta.
            <br/>
            <br/>
            Algunos productos especiales tienen cotizaciones
            específicas.
            <br/>
            <br/>
            Contáctanos para obtener una cotización exacta.
          </p>

          <br/>

          <a href={generateWhatsappLink('5117064549', 'Hola Qempo! Quiero cotizar un producto de la categoría OTROS')}
             target="_blank"
             className={classNames(buttonStyle.btn, buttonStyle.lightBlue, style.modalButton)}>
            Contactar por WhatsApp
          </a>
        </Modal>
      </Fragment>
    );
  }
}

AmazonProductForm.propTypes = {
  handleFocusInputText: PropTypes.func.isRequired,
  handleBlurCleave: PropTypes.func.isRequired,
  handleWeightInit: PropTypes.func.isRequired,
  handlePriceInit: PropTypes.func.isRequired,
  handleChangeCleave: PropTypes.func.isRequired,
  handleChangeCategory: PropTypes.func.isRequired,
  handleChangeAmount: PropTypes.func.isRequired,
  handleChangeWeightUnit: PropTypes.func.isRequired,
  handleChangeVolume: PropTypes.func.isRequired,
  handleChangeBoxOption: PropTypes.func.isRequired,
  handleClickAddCart: PropTypes.func.isRequired,
  handleClickBuyNow: PropTypes.func.isRequired,
  categories: PropTypes.array,
  locale: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  localValues: PropTypes.object,
  departureCountry: PropTypes.object.isRequired,
  name: PropTypes.object.isRequired,
  image: PropTypes.object.isRequired,
  description: PropTypes.object.isRequired,
  shipping: PropTypes.string.isRequired,
  price: PropTypes.object.isRequired,
  categoryId: PropTypes.object.isRequired,
  amount: PropTypes.object.isRequired,
  weightUnit: PropTypes.object.isRequired,
  weight: PropTypes.object.isRequired,
  volumeTier: PropTypes.object.isRequired,
  withBox: PropTypes.object.isRequired,
  isScrapping: PropTypes.bool.isRequired,
  hideOptions: PropTypes.bool.isRequired,
  // chosenVariants: PropTypes.object,
  scrappedProduct: PropTypes.object,
  handleChangeDetailOption: PropTypes.func.isRequired,
  getVariantFromStateDetailOption: PropTypes.func.isRequired,
  detailOptions: PropTypes.object,
  vendorData: PropTypes.object,
};

AmazonProductForm.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/new-order/ProductStep/components/AmazonProductForm/AmazonProductForm.jsx